module.exports = __webpack_public_path__ + "app_assets/fonts/Beckett_Medium_PRO_2012.woff";